import React from 'react';
import { observer } from 'mobx-react';
import { useStore } from '@ui/hooks/useStore';
import Box from '@mui/material/Box';

export default function withSection<T extends JSX.IntrinsicAttributes>(
    Component: React.FC<T>,
) {
    return observer((props: T) => {
        const { sidebar } = useStore();
        const isSidebarHidden = sidebar.isSidebarHidden;
        const wrapClass = isSidebarHidden
            ? 'section__wrap_fullscreen'
            : 'section__wrap';
        return (
            <Box className={wrapClass}>
                <Component {...props} />
            </Box>
        );
    });
}
